export const SIEM_CONFIG_TYPES = {
    FILE_BASED: "file_based",
    SYSLOG_BASED: "syslog_based",
    API_BASED: "api_based",
    NOT_CONFIGURED: "not_configured",
  };

  export const LOG_FORMAT ={
    CEF : "CEF",
    CLF : "CLF",
    ELF : "ELF",
    JSON : "JSON",
    NOT_CONFIGURED : "not_configured"
  }
 
export const supported_log_format = ["CEF", "CLF", "ELF", "JSON"]

export const PASSWORD_ROTATION ={
  SUCCESS : "PASSWORD_ROTATION_SUCCESS",
  FAILED : "PASSWORD_ROTATION_FAILED"
}

export const PAM_SESSION_WARNING_THRESHOLD_SECONDS = 600;